import MatchedMap from 'utilities/src/matchedMap';

import { SiteVariantColorEnum } from '../_variantsColors';

import buttonSiteBlackTheme from './black';
import buttonSiteBlueTheme from './blue';
import buttonSiteBrandTheme from './brand';
import buttonSiteGreenTheme from './green';
import buttonSiteWhiteTheme from './white';

const buttonSiteVariantColorThemeMap = new MatchedMap([
  [SiteVariantColorEnum.Black, buttonSiteBlackTheme],
  [SiteVariantColorEnum.Blue, buttonSiteBlueTheme],
  [SiteVariantColorEnum.Brand, buttonSiteBrandTheme],
  [SiteVariantColorEnum.Green, buttonSiteGreenTheme],
  [SiteVariantColorEnum.White, buttonSiteWhiteTheme],
]);

export default buttonSiteVariantColorThemeMap;
